const DEFAULT_IDLE_TIMEOUT_MS = 5000;

const whenIdle = (callback, options) => {
  const timeout = options?.timeout ?? DEFAULT_IDLE_TIMEOUT_MS;

  if ("requestIdleCallback" in window) {
    return window.requestIdleCallback(callback, { ...options, timeout });
  }

  return window.setTimeout(callback, timeout);
};

export default whenIdle;
